import React, { useState, useEffect } from 'react';  
import { Modal, Transfer } from 'antd';  
  
const EditGroupModal = ({ visible, onClose, group, contestants, onSave, saving }) => {  
    const [targetKeys, setTargetKeys] = useState([]);  
    const [selectedKeys, setSelectedKeys] = useState([]);  
  
    useEffect(() => {  
        if (group) {  
            const groupMemberIds = group.group.map(member => member.group_member._id);  
            setTargetKeys(groupMemberIds);  
        }  
    }, [group]);  
  
    const handleChange = (nextTargetKeys) => {  
        setTargetKeys(nextTargetKeys);  
    };  
  
    const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {  
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);  
    };  
  
    const handleSave = () => {  
        onSave(group._id, targetKeys);  
    };  
  
    return (  
        <Modal  
            visible={visible}  
            title="Edit Group Members"  
            onCancel={onClose}  
            onOk={handleSave}  
            confirmLoading={saving} // Add loader to the Save button  
        >  
            <Transfer  
                dataSource={contestants}  
                showSearch  
                targetKeys={targetKeys}  
                selectedKeys={selectedKeys}  
                onChange={handleChange}  
                onSelectChange={handleSelectChange}  
                render={item => `${item.first_name} ${item.last_name}`}  
                rowKey={item => item._id}  
            />  
        </Modal>  
    );  
};  
  
export default EditGroupModal;  